import React, { Component } from 'react';
import AppContext from 'components/appContext';

class UserName extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="user-details__name">{this.context.userDetails.NAME}</div>
            </React.Fragment>
        )
    }
}

export default UserName;